import styled from 'styled-components'
import { ButtonBase, styled as muiStyled } from '@mui/material'
import { Link } from 'react-router-dom'

export const ArticleLayoutCardsContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  scroll-behavior: smooth;
  gap: 25px;
  -webkit-overflow-scrolling: touch; /* For iOS devices */
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  padding: 20px;
  @media (min-width: 768px) {
    padding: 35px;
  }
`

export const ArticleLayoutImage = styled.div`
  width: 45%;
  background-image: url(${(props) => props.imgURL});
  background-repeat: no-repeat;
  background-size: cover;
`

export const ArticleLayoutNumber = styled.div`
  position: absolute;
  font-style: normal;
  color: #ffffff;
  bottom: 10px;
  left: 10px;
  font-weight: 700;
  font-size: 18px;
  @media (min-width: 768px) {
    bottom: 15px;
    left: 15px;
    font-weight: 700;
    font-size: 21px;
  }
  @media (min-width: 1296px) {
    bottom: 15px;
    left: 15px;
    font-weight: 700;
    font-size: 24px;
  }
`

export const ArticleLayoutCardBackground = styled.img`
  width: 100%;
  transition: transform 0.5s ease-in-out;
  aspect-ratio: 2;
  width: 100%;
  object-fit: cover;
`

export const ArticleLayoutCardDetails = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  bottom: 0;
  color: #ffffff;
  gap: 12px;
  height: 100%;

  transition: transform 0.5s ease-in-out;
`

export const ArticleLayoutAppExclusiveText = styled.div`
  background: rgba(0, 0, 0, 0.44);
  backdrop-filter: blur(8.5px);
  /* Note: backdrop-filter has minimal browser support */
  text-align: center;
  display: flex;
  align-items: center;
  gap: 3px;

  font-size: 8px;
  margin-top: 8px;
  padding: 2px 5px;
  border-radius: 15px;

  @media (min-width: 768px) {
    font-size: 12px;
    margin-top: 10px;
    padding: 3px 5px;
    border-radius: 20px;
  }
  @media (min-width: 1024px) {
    font-size: 16px;
    margin-top: 12px;
    padding: 5px 10px;
    border-radius: 25px;
  }
`

export const ArticleLayoutCardCategory = styled.div`
  background: rgba(0, 0, 0, 0.38);
  backdrop-filter: blur(14px);
  color: #ffffff;

  font-style: normal;
  font-weight: 400;
  width: fit-content;
  cursor: default;

  padding: 2px;
  border-radius: 16px;
  font-size: 10px;
  line-height: 8px;

  @media (min-width: 768px) {
    padding: 4px;
    border-radius: 21px;
    font-size: 12px;
    line-height: 12px;
  }
  @media (min-width: 1024px) {
    padding: 7px;
    border-radius: 28px;
    font-size: 16px;
    line-height: 16px;
  }
`

export const ArticleLayoutTitle = muiStyled('div')(
  ({ theme, lightMode }) => `
color: ${lightMode ? '#000' : '#fff'};

font-style: normal;
display: flex;
justify-content: flex-start;
line-height: 1.1;
font-size: 18px;
@media(min-width: 768px){
  font-size:20px;
}
`,
)

export const SquareCardActionButton = styled.div`
  opacity: 0;
  transition: opacity 0.5s ease-out;
  display: flex;
  background: #ffffff;
  border-radius: 6px;
  justify-content: center;
  align-items: center;

  font-style: normal;
  font-weight: 600;
  color: #000000;
  cursor: pointer;

  font-size: 8px;
  width: 75px;
  height: 20px;
  margin-top: 6px;

  @media (min-width: 768px) {
    font-size: 12px;
    width: 100px;
    height: 25px;
    margin-top: 9px;
  }
  @media (min-width: 1024px) {
    font-size: 16px;
    width: 150px;
    height: 40px;
    margin-top: 12px;
  }
`

function ArticleLayoutCardContainerStyles() {
  return ({ theme, nopointer, inFlexContainer, maxWidth }) => {
    return `
   text-decoration: none;
   color: unset;
max-width: ${maxWidth};
width: 100%;
border-radius: 10px;
position: relative;
background: rgb(0 0 0 / 12%);
overflow: hidden;
display: flex;
justify-content: flex-start;
padding: 15px;
text-align:left;
gap: 10px;
height: ${inFlexContainer ? 'unset' : '100%'};
flex-shrink: 0;
flex-direction: column;
cursor: ${nopointer ? 'unset' : 'pointer'};
transition: background 300ms ${theme.transitions.easing.quickInOut};
&:hover {
  background: rgb(0 0 0 / 30%);
}
${
  '' /* @media (min-width: 768px) {
  flex: 0 0 229px;
  height: 238px;
  margin-right: 60px;
  border-radius: 8px;
} */
}
${
  '' /* @media (min-width: 1024px) {
  flex: 0 0 329px;
  height: 338px;
  margin-right: 90px;
  border-radius: 10px;
} */
}
`
  }
}
export const ArticleLayoutCardContainer = muiStyled(ButtonBase, {
  shouldForwardProp: (prop) => !['nopointer', 'inFlexContainer', 'maxWidth', 'bgColor'].includes(prop),
})(ArticleLayoutCardContainerStyles('div'))
export const ArticleLayoutCardAnchor = muiStyled(Link, {
  shouldForwardProp: (prop) => !['nopointer', 'inFlexContainer', 'maxWidth', 'bgColor'].includes(prop),
})(ArticleLayoutCardContainerStyles())

export const ArticleLayoutCardSecondaryText = muiStyled('div')(
  ({ theme, lightMode }) => `
color: ${lightMode ? '#0000009c' : '#ffffff'};
// display: none;
font-style: normal;
font-weight: 400;
width: fit-content;
overflow: hidden;
text-overflow: ellipsis;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;

padding: 2px;
border-radius: 16px;
font-size: 12px;
line-height: 18px;

display: -webkit-box;
`,
)
